export default {
    columns: [],
    // customSearchParams: {},
    // callback func
    onAjaxDataResponse: function(data) {
      console.log("onAjaxDataResponse",data);
    },
    onClickAdd: function() {
      console.log("onClickAdd");
    },
    onClickRefresh: function() {
      console.log("onClickRefresh");
    },
    onClickView: function(data) {
      console.log("onClickView");
    },
    onClickEdit: function(data) {
      console.log("onClickEdit",data);
    },
    onClickDelete: function(data) {
      console.log("onClickDelete",data);
    },
    onConfirmDelete: function(data) {
      console.log("onConfirmDelete",data);
    },
    // submit
    onSubmitAdd: function(data) {
      console.log("onSubmitAdd",data);
    },
    onSubmitEdit: function(data) {
      console.log("onSubmitEdit",data);
    }
  }